import React from 'react';
import PropTypes from 'prop-types';

function Button({
	children,
	disabled,
	onClick,
	className,
	type = 'button',
	onMouseEnter,
	onMouseLeave,
}) {
	return (
		<button
			onClick={onClick}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
			disabled={disabled}
			className={className}
			// eslint-disable-next-line react/button-has-type
			type={type || 'button'}
		>
			{children}
		</button>
	);
}

Button.propTypes = {
	children: PropTypes.node,
	onClick: PropTypes.func,
	onMouseEnter: PropTypes.func,
	onMouseLeave: PropTypes.func,
	className: PropTypes.string,
	disabled: PropTypes.bool,
	type: PropTypes.string,
};

Button.defaultProps = {
	type: 'button',
};

export default Button;
